import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";

export const useConfirmInvitationCompanyOneTimePassword = (oneTimePassword: string) => {
	const [canRender, setCanRender] = useState(false);

	const navigate = useNavigate();

	useEffect(() => {
		const callback = () => {
			if (!oneTimePassword || !decodeURI(oneTimePassword)) {
				notifyUserEventInfo({
					title: "無効なURLです",
					description: "カスタマーサポートへお問い合わせください",
				});
				navigate(PATHS.AUTH.SIGN_IN);
			} else {
				setCanRender(true);
			}
		};

		callback();
	}, [oneTimePassword, navigate]);

	return {
		canRender,
	};
};
